import { c as _c } from "react/compiler-runtime";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import BackLink from "./BackLink";
import NotFoundContent from "./NotFoundContent";
export default function NotFoundPage(t0) {
  const $ = _c(27);
  const {
    appName: t1,
    messages: t2,
    defaultTitle: t3,
    defaultDescription: t4
  } = t0;
  const appName = t1 === undefined ? "Catchy" : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const messages = t5;
  const defaultTitle = t3 === undefined ? "404" : t3;
  const defaultDescription = t4 === undefined ? "Page not found" : t4;
  const router = useRouter();
  const [errorPath, setErrorPath] = useState(null);
  let t6;
  let t7;
  if ($[2] !== router.asPath) {
    t6 = () => {
      const path = router.asPath || window.location.pathname;
      setErrorPath(path.split("/")[1] || null);
    };
    t7 = [router.asPath];
    $[2] = router.asPath;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  const title = errorPath === "stop" ? "This stop is not available" : errorPath === "trip" ? "Unable to get trip information." : defaultTitle;
  const pageTitle = `${title} - ${appName}`;
  let t10;
  let t8;
  let t9;
  if ($[5] !== pageTitle) {
    t8 = <title key="title">{pageTitle}</title>;
    t9 = <meta name="twitter:text:title" content={pageTitle} key="twitterTitle" />;
    t10 = <meta property="og:title" content={pageTitle} key="ogTitle" />;
    $[5] = pageTitle;
    $[6] = t10;
    $[7] = t8;
    $[8] = t9;
  } else {
    t10 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <meta name="robots" content="noindex" />;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t12 = <Head>{t8}{t9}{t10}{t11}</Head>;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <BackLink />;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== router) {
    t14 = () => router.reload();
    $[15] = router;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== appName || $[18] !== defaultDescription || $[19] !== defaultTitle || $[20] !== errorPath || $[21] !== messages || $[22] !== t14) {
    t15 = <NotFoundContent appName={appName} backControl={t13} defaultDescription={defaultDescription} defaultTitle={defaultTitle} errorPath={errorPath} messages={messages} onRetry={t14} />;
    $[17] = appName;
    $[18] = defaultDescription;
    $[19] = defaultTitle;
    $[20] = errorPath;
    $[21] = messages;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t15) {
    t16 = <>{t12}{t15}</>;
    $[24] = t12;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}